import { getState } from 'lib/store'
import type { ApiKey } from 'types/settings/api-keys'

export const getApiKeys = (): ApiKey[] =>
  getState().settings?.apiKeys?.items ?? []

export const isFetchingApiKeys = (): boolean =>
  getState().settings?.apiKeys?.isFetching ?? false

export const isCreatingApiKey = (): boolean =>
  getState().settings?.apiKeys?.isCreating ?? false
